export const validateFitnessProfileForm = (formValues) => {
  let errors = {};

  if (!formValues.selGender) {
    errors.selGender = "required!";
  }

  if (!formValues.selMemAge) {
    errors.selMemAge = "required!";
  }

  if (formValues.isCmHeight && !formValues.selMemHeightInCm) {
    errors.selMemHeightInCm = "required!";
  }

  if (!formValues.isCmHeight && !formValues.selMemHeightInFt) {
    errors.selMemHeightInFt = "required!";
  }

  if (!formValues.memWeight) {
    errors.memWeight = "required!";
  }

  if (!formValues.memTargetWeight) {
    errors.memTargetWeight = "required!";
  }

  if (!formValues.memWaist) {
    errors.memWaist = "required!";
  }

  // if (!formValues.memNeck) {
  //   errors.memNeck = "required!";
  // }

  // if (!formValues.memHip) {
  //   errors.memHip = "required!";
  // }

  if (!formValues.selBodyType) {
    errors.selBodyType = "required!";
  }

  if (!formValues.selActivity) {
    errors.selActivity = "required!";
  }

  if (!formValues.selDietPreference) {
    errors.selDietPreference = "required!";
  }

  if (
    formValues.selMedicalIssue?.length === 1 &&
    formValues.selMedicalIssue?.some((goal) => goal.value === "other") &&
    !formValues.otherMedicalIssue
  ) {
    errors.otherMedicalIssue = "required!";
  }

  return errors;
};

export function calculateBMI(bmiValues) {
  try {
    const { ft, inch, kgs } = bmiValues || {};
    const feet = parseFloat(ft);
    const inches = parseFloat(inch);
    const weightInKgs = parseFloat(kgs);

    if (isNaN(feet) || isNaN(inches) || isNaN(weightInKgs)) {
      return 0;
    } else {
      const heightInMeters = (feet * 12 + inches) * 0.0254;
      const bmi = (weightInKgs / (heightInMeters * heightInMeters)).toFixed(1);
      return isNaN(bmi) ? 0 : bmi;
    }
  } catch (error) {
    console.log(error);
    return 0;
  }
}

export function getBMICategory(bmi) {
  const bmiRanges = [
    { name: "Under Weight", min: 0, max: 18.5 },
    { name: "Healthy", min: 18.5, max: 24.9 },
    { name: "Over Weight", min: 24.9, max: 29.9 },
    { name: "Obese", min: 30, max: 40 },
  ];

  for (let i = 0; i < bmiRanges.length; i++) {
    if (bmi >= bmiRanges[i].min && bmi <= bmiRanges[i].max) {
      return { rangeIndex: i, name: bmiRanges[i].name };
    }
  }

  return { rangeIndex: -1, name: "No Fitness Profile" };
}

export function calculateTDEE(weight, height, age, activityLevel, gender) {
  let totalTdee = 0;

  if (gender === "female") {
    totalTdee = 10 * weight + 6.25 * height - 5 * age - 161;
  } else {
    totalTdee = 10 * weight + 6.25 * height - 5 * age + 5;
  }

  let finalTdee;

  if (activityLevel === 0) {
    finalTdee = totalTdee * 1.2;
  } else if (activityLevel === 1) {
    finalTdee = totalTdee * 1.375;
  } else if (activityLevel === 2) {
    finalTdee = totalTdee * 1.55;
  } else if (activityLevel === 3) {
    finalTdee = totalTdee * 1.725;
  } else if (activityLevel === 4) {
    finalTdee = totalTdee * 1.9;
  }

  return finalTdee.toFixed();
}

export function calculateBMR(weight, height, age, gender) {
  let totalBMR = 0;

  if (gender === "female") {
    totalBMR = 10 * weight + 6.25 * height - 5 * age - 161;
  } else {
    totalBMR = 10 * weight + 6.25 * height - 5 * age + 5;
  }

  return totalBMR.toFixed();
}

export function calculateBodyFatPercentage1(
  waist,
  neck,
  heightInInches,
  weightLb,
  ageNumber
) {
  const bodyFatPercentage = parseFloat(
    495 /
      (1.0324 -
        0.19077 * Math.log(waist - neck) +
        0.15456 * Math.log(heightInInches)) -
      0.45 * weightLb +
      0.1 * ageNumber
  );

  const value = parseFloat(bodyFatPercentage / 10);

  return {
    bodyFatPercentage: bodyFatPercentage.toFixed(2),
    value: value.toFixed(2),
  };
}

export function calculateBMIForBodyFat(weightKg, heightCm) {
  const heightM = heightCm / 100;
  const finalBmi = weightKg / (heightM * heightM);
  return finalBmi.toFixed(2);
}

export function calculateBodyFatPercentage(weightKg, heightCm, age, gender) {
  const bmi = calculateBMIForBodyFat(weightKg, heightCm);

  let bfp;
  if (age >= 18) {
    if (gender === "male") {
      bfp = 1.2 * bmi + 0.23 * age - 16.2;
    } else if (gender === "female") {
      bfp = 1.2 * bmi + 0.23 * age - 5.4;
    }
  } else {
    if (gender === "male") {
      bfp = 1.51 * bmi - 0.7 * age - 2.2;
    } else if (gender === "female") {
      bfp = 1.51 * bmi - 0.7 * age + 1.4;
    }
  }

  return {
    bodyFatPercentage: bfp.toFixed(2),
  };
}

export function calculateDailyCalorie(
  weightKg,
  heightCm,
  age,
  gender,
  activityLevel
) {
  let totalCal;
  const bmr = calculateBMR(weightKg, heightCm, age, gender);
  if (activityLevel === 0) {
    totalCal = bmr * 1.2;
  } else if (activityLevel === 1) {
    totalCal = bmr * 1.375;
  } else if (activityLevel === 2) {
    totalCal = bmr * 1.55;
  } else if (activityLevel === 3) {
    totalCal = bmr * 1.725;
  } else if (activityLevel === 4) {
    totalCal = bmr * 1.9;
  }

  return totalCal?.toFixed(2);
}

export function calculateTargetBMR(
  targetWeight,
  height,
  age,
  gender,
  activityLevel
) {
  const targetBmr = calculateBMR(targetWeight, height, age, gender);
  let activityFactor = 1.2;

  switch (activityLevel) {
    case 0:
      activityFactor = 1.2;
      break;
    case 1:
      activityFactor = 1.375;
      break;
    case 2:
      activityFactor = 1.55;
      break;
    case 3:
      activityFactor = 1.725;
      break;
    case 4:
      activityFactor = 1.9;
      break;
    default:
      console.warn("Unknown activity level. Using sedentary activity factor.");
  }

  const targetBMR = targetBmr * activityFactor;

  return targetBMR.toFixed(2);
}

export function calculateTargetCalorie(
  targetWeightKg,
  heightCm,
  age,
  gender,
  activityLevel
) {
  let totalTagertCal;
  const targetBmr = calculateTargetBMR(
    targetWeightKg,
    heightCm,
    age,
    gender,
    activityLevel
  );

  if (activityLevel === 0) {
    totalTagertCal = targetBmr * 1.2;
  } else if (activityLevel === 1) {
    totalTagertCal = targetBmr * 1.375;
  } else if (activityLevel === 2) {
    totalTagertCal = targetBmr * 1.55;
  } else if (activityLevel === 3) {
    totalTagertCal = targetBmr * 1.725;
  } else if (activityLevel === 4) {
    totalTagertCal = targetBmr * 1.9;
  }

  return targetBmr?.toFixed(2);
}
